import { CodeIcon } from "@heroicons/react/solid";
import ProjectCard from "./ProjectCard";
import React from "react";
import { projects } from "../data/projects";

const Projects = () => {
  return (
    <section id="projects" className="font-body">
      <div className="container px-5 py-10 mx-auto text-center lg:px-40">
        <div className="flex flex-col w-full mb-16">
          <CodeIcon className="mx-auto inline-block w-10 mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium font-title mb-4">
            Projects
          </h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
            Here are some of the coding projects I've done.
          </p>
        </div>
        <div className="flex flex-wrap justify-between">
          {projects.map((project, index) => (
            <ProjectCard key={index} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
}
export default Projects;


// WEBPACK FOOTER //
// ./src/components/Projects.jsx